module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "list list-box p0002"
  }, [_c('li', {
    staticClass: "list-item"
  }, [_c('menu-vertical', [_c('span', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_vm._v("值 " + _vm._s(_vm.val))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "slot": "dock"
    },
    slot: "dock"
  }, [_c('bo-number', {
    attrs: {
      "max": "5",
      "value": "0"
    },
    on: {
      "on-change": _vm.change
    }
  })], 1)])], 1), _vm._v(" "), _c('li', {
    staticClass: "list-item"
  }, [_c('menu-vertical', [_c('span', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_vm._v("大小上下限 " + _vm._s(_vm.val2))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "slot": "dock"
    },
    slot: "dock"
  }, [_c('bo-number', {
    attrs: {
      "max": "5",
      "min": "2"
    },
    on: {
      "on-max": _vm.max,
      "on-min": _vm.min
    },
    model: {
      value: (_vm.val2),
      callback: function($$v) {
        _vm.val2 = $$v
      },
      expression: "val2"
    }
  })], 1)])], 1), _vm._v(" "), _c('li', {
    staticClass: "list-item"
  }, [_c('menu-vertical', [_c('span', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_vm._v("数据回滚")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "slot": "dock"
    },
    slot: "dock"
  }, [_c('bo-number', {
    ref: "number",
    attrs: {
      "value": _vm.val3
    },
    on: {
      "on-change": _vm.rollback
    }
  })], 1)])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6e1e4813!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/bo-number/demo.vue
// module id = 264
// module chunks = 31